<template>
  <div class="spinner" :style="color">
    <i class="fa fa-circle-o-notch fa-spin"></i>
  </div>
</template>

<script>
export default {
  computed: {
    color () {
      return {
        color: this.$engine.services.getCardBackgroundColor(this.$engine.user.currentService.id)
      }
    }
  }
}
</script>

<style lang="css" scoped>
.spinner {
  font-size: 28px;
  text-align:center;
  padding: inherit;
}
</style>



// WEBPACK FOOTER //
// spinner.vue?5ff60a06